// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"40034295","386":"d2e5ad28"}[chunkId] + ".chunk.js";
};